import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button';
import UserAvatar from 'components/UserAvatar';
import ReportCardPreview from '../ReportCardPreview';
// utils
import classnames from 'classnames/bind';
import mixpanel from 'mixpanel-browser';
// styles
import styles from './DraftReportCard.module.scss';

const cn = classnames.bind(styles);

const DraftReportCard = (
  { isFlagged, onContinue, onDelete, reportUser, currentUser, reportId, farmId, templateId, svrCategories }
) => {
  const handleContinue = () => {
    if (currentUser && currentUser.id) {
      mixpanel.track('Feature Used', {
        user_id: currentUser.id,
        feature_name: 'DraftReportCard',
        action: 'Click Continue',
        report_id: reportId,
        farm_id: farmId,
        template_id: templateId,
        report_user_id: reportUser?.id,
        is_flagged: isFlagged,
        timestamp: new Date().toISOString()
      });
    }
    onContinue();
  };

  const handleDelete = () => {
    if (currentUser && currentUser.id) {
      mixpanel.track('Feature Used', {
        user_id: currentUser.id,
        feature_name: 'DraftReportCard',
        action: 'Click Delete',
        report_id: reportId,
        farm_id: farmId,
        template_id: templateId,
        report_user_id: reportUser?.id,
        is_flagged: isFlagged,
        timestamp: new Date().toISOString()
      });
    }
    onDelete();
  };

  return (
    <div className={cn('draft-report-card', { 'is-flagged': isFlagged })}>
      <div className={cn('bg')} />
      <div className={cn('top-content')}>
        <UserAvatar user={reportUser} size={25} />
        <div className={cn('status-badge')}>
          <FormattedMessage id="general.status.draft" />
        </div>
        <i onClick={handleDelete} className={cn('fa fa-times', 'delete-btn')} />
      </div>
      <ReportCardPreview svrCategories={svrCategories} />
      <Button onClick={handleContinue} primary className={cn('continue-button')}>
        <FormattedMessage id="general.button.continue" />
      </Button>
    </div>
  );
};

DraftReportCard.propTypes = {
  reportUser: T.object.isRequired,
  isFlagged: T.bool.isRequired,
  onContinue: T.func.isRequired,
  onDelete: T.func.isRequired,
  currentUser: T.object,
  reportId: T.string,
  farmId: T.string,
  templateId: T.string,
  svrCategories: T.array,
};

export default DraftReportCard;
